import {
    ITopicsContextState,
    TopicsContextDispatchMessage,
    TopicsContextDispatchMessageType
} from "./TopicsContext.interfaces";
import {ITopic} from "../../Interfaces/Topic";

export const initialState: ITopicsContextState = {
    loaded: false,
    list: new Array<ITopic>(),
}

export const reducer = (prevState: ITopicsContextState, payloads: Array<TopicsContextDispatchMessage>): ITopicsContextState => {
    const newState: ITopicsContextState = {...prevState};
    payloads.forEach(payload => {
        const payloadType = payload.type;
        switch (payloadType) {
            case TopicsContextDispatchMessageType.SetList:
                newState.list = payload.list;
                break;
            case TopicsContextDispatchMessageType.SetLoaded:
                newState.loaded = payload.value;
                break;
            case TopicsContextDispatchMessageType.AddUpdateTopic:
                newState.list = [...newState.list];
                newState.list = newState.list.filter(t => t.id !== payload.topic.id);
                newState.list.push(payload.topic);
                break;
            case TopicsContextDispatchMessageType.DeleteTopic:
                newState.list = [...newState.list];
                newState.list = newState.list.filter(t => t.id !== payload.id);
                break;
            default:
                throw new Error("Message " + TopicsContextDispatchMessageType[payloadType] + " not implemented");
        }
    });
    return newState;
}